import { render, staticRenderFns } from "./SolutionDetail.vue?vue&type=template&id=585f50c7&scoped=true"
import script from "./SolutionDetail.vue?vue&type=script&lang=js"
export * from "./SolutionDetail.vue?vue&type=script&lang=js"
import style0 from "./SolutionDetail.vue?vue&type=style&index=0&id=585f50c7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585f50c7",
  null
  
)

export default component.exports